export const subsiteRouters = [
  //子站门户
  {
    //链接路径
    path: "/:pgId",
    //路由名称，
    name: "subSite",
    //对应的组件模板
    component: () => import("../views/Home.vue"),
    redirect: {
      name: "HomeMain"
    },
    //子路由,嵌套路由
    children: [
      {
        path: "main",
        name: "HomeMain",
        component: () => import("../views/Home/HomeMain.vue"),
        meta: {
          title: "子站首页"
        }
      },
      {
        path: "introduction",
        name: "Introduction",
        component: () => import("../views/Home/Introduction.vue"),
        meta: {
          title: "专业群介绍"
        }
      },
      {
        path: "containmajor",
        name: "containmajor",
        component: () => import("../views/Home/containMajor.vue"),
        meta: {
          title: "组群专业"
        }
      },
      {
        path: "homecourse",
        name: "HomeCourse",
        component: () => import("../views/Home/HomeCourse.vue"),
        meta: {
          title: "专业群课程课程"
        }
      },
      {
        path: "groupLogic",
        name: "groupLogic",
        component: () => import("../views/Home/GroupLogic.vue"),
        meta: {
          title: "组建逻辑"
        }
      },
      {
        path: "courseDetail/:courseOpenId",
        name: "HomeCourseDetail",
        props: true,
        component: () => import("../views/CourseDetail/index.vue"),
        meta: {
          title: "课程详情"
        }
      },
      {
        path: "defaultIntroduction/:id",
        name: "defaultIntroduction",
        props: true,
        component: () =>
          import("../views/temp-default/defaultIntroduction.vue"),
        meta: {
          title: "介绍"
        }
      }
      //red
      // {
      //   path: "tempTwo",
      //   name: "tempTwo",
      //   props: true,
      //   component: () => import("../views/temp-two/HomeMain.vue"),
      //   meta: {
      //     title: ""
      //   }
      // }
    ]
  }
];
